import {
  Component, ElementRef, Output, EventEmitter, ViewChild, Input
} from '@angular/core';

// See ./LICENSE for origin and copyright notices.
@Component({
  selector: 'mention-list',
  styles: [`
      .scrollable-menu {
        display: block;
        height: auto;
        max-height: 300px;
        overflow: auto;
      }
    `,`
      [hidden] {
        display: none;
      }
    `,`
      li.active {
        background-color: #f7f7f9;
      }
    `],
  template: `
    <ul #list [hidden]="hidden" class="dropdown-menu scrollable-menu">
      <a *ngFor="let item of items; let i = index" class="dropdown-item" (mousedown)="activeIndex=i;itemClick.emit();$event.preventDefault()">
        <li [class.active]="activeIndex==i">{{item[labelKey]}}</li>
      </a>
    </ul>
    `
})
export class MentionListComponent {
  @Input() labelKey: string = 'label';
  @Output() itemClick = new EventEmitter();
  @ViewChild('list', { static: false }) list!: ElementRef;
  items: Array<any> = [];
  activeIndex: number = 0;
  hidden: boolean = true;

  get activeItem() {
    return this.items[this.activeIndex];
  }

  activateNextItem() {
    // adjust scrollable-menu offset if the next item is out of view
    let listEl: HTMLElement = this.list.nativeElement;
    let activeEl = listEl.getElementsByClassName('active').item(0);
    if (activeEl) {
      let nextLiEl: HTMLElement = <HTMLElement> activeEl.nextSibling;
      if (nextLiEl && nextLiEl.nodeName == "LI") {
        let nextLiRect: ClientRect = nextLiEl.getBoundingClientRect();
        if (nextLiRect.bottom > listEl.getBoundingClientRect().bottom) {
          listEl.scrollTop = nextLiEl.offsetTop + nextLiRect.height - listEl.clientHeight;
        }
      }
    }
    // select the next item
    this.activeIndex = Math.max(Math.min(this.activeIndex + 1, this.items.length - 1), 0);
  }

  activatePreviousItem() {
    // adjust the scrollable-menu offset if the previous item is out of view
    let listEl: HTMLElement = this.list.nativeElement;
    let activeEl = listEl.getElementsByClassName('active').item(0);
    if (activeEl) {
      let prevLiEl: HTMLElement = <HTMLElement> activeEl.previousSibling;
      if (prevLiEl && prevLiEl.nodeName == "LI") {
        let prevLiRect: ClientRect = prevLiEl.getBoundingClientRect();
        if (prevLiRect.top < listEl.getBoundingClientRect().top) {
          listEl.scrollTop = prevLiEl.offsetTop;
        }
      }
    }
    // select the previous item
    this.activeIndex = Math.max(Math.min(this.activeIndex - 1, this.items.length - 1), 0);
  }

  resetScroll() {
    this.list.nativeElement.scrollTop = 0;
  }
}
